import { SUBSCRIPTION_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import { ADMIN_SUBSCRIBER_SUFFIX } from "./Subscriber.constants.js";
import ___default from "lodash";
function convertSubscribers(notifierResults) {
  var notifierItems = (notifierResults == null ? void 0 : notifierResults.map((f) => convertSubscriber(f))) || [];
  return notifierItems;
}
function convertSubscriber(subscriberDto) {
  return {
    id: subscriberDto.id,
    text: subscriberDto.displayName,
    primaryText: subscriberDto.mailNickname,
    secondaryText: subscriberDto.mail,
    tertiaryText: subscriberDto.department,
    optionalText: subscriberDto.mailNickname,
    imageUrl: subscriberDto.userPhotoBase64,
    isValid: true,
    type: subscriberDto.type,
    tenantId: subscriberDto.tenantId
  };
}
function convertSubscribersV2(notifierResults) {
  var notifierItems = (notifierResults == null ? void 0 : notifierResults.map((f) => convertSubscriberV2(f))) || [];
  return notifierItems;
}
function convertSubscriberV2(subscriberDto) {
  return {
    id: subscriberDto.id,
    text: subscriberDto.displayName,
    primaryText: subscriberDto.emailNickname,
    secondaryText: subscriberDto.emailId,
    tertiaryText: subscriberDto.department,
    optionalText: subscriberDto.emailNickname,
    imageUrl: subscriberDto.userPhotoBase64,
    isValid: true,
    type: subscriberDto.type,
    tenantId: subscriberDto.tenantId,
    subscriptionType: subscriberDto.subscriptionType
  };
}
function getProcessedSubscriberPersona(items) {
  let newItems = [];
  items == null ? void 0 : items.map((item) => {
    const newItem = {
      id: !!item.id ? item.id : item.primaryText,
      imageUrl: item.imageUrl,
      imageInitials: item.imageInitials,
      text: !!item.id ? item.text : item.primaryText,
      primaryText: item.primaryText,
      secondaryText: item.secondaryText,
      tertiaryText: item.tertiaryText,
      optionalText: item.optionalText,
      presence: item.presence,
      isValid: item.isValid,
      canExpand: item.canExpand,
      type: !!item.id ? item.type : "Email",
      tenantId: item.tenantId,
      subscriptionType: item.subscriptionType
    };
    newItems.push(newItem);
  });
  return newItems;
}
function convertSubscriberToUnified(subscriberDto) {
  return {
    id: subscriberDto.id,
    type: subscriberDto.type,
    displayName: subscriberDto.displayName,
    emailId: subscriberDto.mail,
    emailNickname: subscriberDto.mailNickname,
    userPrincipalName: subscriberDto.userPrincipalName,
    department: subscriberDto.department,
    userPhotoBase64: subscriberDto.userPhotoBase64,
    tenantId: subscriberDto.tenantId,
    subscriptionType: SUBSCRIPTION_TYPES.EntityBase
  };
}
function convertSubscribersToUnified(notifierResults) {
  var notifierItems = (notifierResults == null ? void 0 : notifierResults.map((f) => convertSubscriberToUnified(f))) || [];
  return notifierItems;
}
function mapSubscribersSetPayload(subscribers) {
  return (subscribers == null ? void 0 : subscribers.map(
    (s) => !!s.id ? { id: s.id, type: s.type, tenantId: s.tenantId, subscriptionType: s.subscriptionType } : { id: s.primaryText, type: "Email", subscriptionType: s.subscriptionType }
  )) || [];
}
function getMergedSubscribers(subscribersData, notificationCategory, experimentationGroupId) {
  var _a, _b;
  let entitySubscribers = [];
  let allUniqueAdminSubscribers = [];
  let mergedSubscribers = [];
  if (!!((_a = subscribersData == null ? void 0 : subscribersData.value) == null ? void 0 : _a.length) && (subscribersData == null ? void 0 : subscribersData.value[0].subscriptionType) === SUBSCRIPTION_TYPES.EntityBase) {
    entitySubscribers = subscribersData == null ? void 0 : subscribersData.value[0].subscribers;
    entitySubscribers = entitySubscribers.map((s) => {
      s.subscriptionType = SUBSCRIPTION_TYPES.EntityBase;
      return s;
    });
  }
  if (!!notificationCategory && !!((_b = subscribersData == null ? void 0 : subscribersData.value) == null ? void 0 : _b.length)) {
    allUniqueAdminSubscribers = ___default(subscribersData == null ? void 0 : subscribersData.value).filter(
      (f) => f.subscriptionType === SUBSCRIPTION_TYPES.Admin && inExperimentationGroups(f.experimentationGroups, experimentationGroupId)
    ).map((f) => f.subscribers).flatten().uniqBy((f) => f.id).map((s) => {
      var _a2;
      s.displayName = ((_a2 = s.displayName) == null ? void 0 : _a2.endsWith(ADMIN_SUBSCRIBER_SUFFIX)) ? s.displayName : s.displayName + ADMIN_SUBSCRIBER_SUFFIX;
      s.subscriptionType = SUBSCRIPTION_TYPES.Admin;
      return s;
    }).value();
  }
  mergedSubscribers = [...allUniqueAdminSubscribers, ...entitySubscribers];
  return mergedSubscribers;
}
function inExperimentationGroups(experimentationGroups, experimentationGroupId) {
  if (!experimentationGroups || !experimentationGroupId) {
    return true;
  } else {
    experimentationGroupId = experimentationGroupId.toLocaleLowerCase();
    return experimentationGroups.findIndex(
      (g) => g.toLocaleLowerCase() === experimentationGroupId || (experimentationGroupId == null ? void 0 : experimentationGroupId.startsWith(g.toLocaleLowerCase()))
    ) >= 0;
  }
}
export {
  convertSubscriber,
  convertSubscriberToUnified,
  convertSubscriberV2,
  convertSubscribers,
  convertSubscribersToUnified,
  convertSubscribersV2,
  getMergedSubscribers,
  getProcessedSubscriberPersona,
  inExperimentationGroups,
  mapSubscribersSetPayload
};
//# sourceMappingURL=Subscriber.utils.js.map
